// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FactorStatistics_wrapper__3Mo5A"};